import { observer, useViewModel } from '@descomplica/microfrontend-react';
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';

import IconComponent from '@/presentation/components/icon/icon';

import { ExamViewModel } from '../../exam.vm';
import { ExamTimerViewModel } from './exam-timer.vm';

const TimerContainer = styled.div`
  display: flex;
  padding: 32px 24px 24px 48px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  width: 15%;
`;

const TimerContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
`;

const TimerTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;
  align-self: stretch;

  & > span {
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: Aprova Nova;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
  }

  & > svg {
    cursor: pointer;
  }
`;

const TimerInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`;

const RemainingTime = styled.span`
  font-family: Aprova Nova;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
`;

const TotalTime = styled.span`
  color: #96999c;
  font-family: Aprova Nova;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
`;

const TimerSkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
`;

const RemainingTimeSkeleton = styled.span`
  width: 100px;
  height: 24px;
  border-radius: 4px;
  background: #caccce;
`;

const TotalTimeSkeleton = styled.span`
  width: 89px;
  height: 16px;
  border-radius: 4px;
  background: #caccce;
`;

export const ExamTimer: React.FC<any> = ({ minutes }: { minutes: number }) => {
  const vm = useViewModel(ExamTimerViewModel);
  const examVm = useViewModel(ExamViewModel);
  const navigate = useNavigate();
  const { guid } = useParams();

  vm.setIntervalSeconds(minutes * 60);

  const startCountdown = (duration: number) => {
    let secondsLeft = duration;
    const countdownInterval = setInterval(() => {
      vm.setCount(secondsLeft);
      secondsLeft--;
      localStorage.setItem('countdownDuration', secondsLeft.toString());

      if (secondsLeft < 0) {
        clearInterval(countdownInterval);
        localStorage.setItem('countdownDuration', vm.count.toString());
        if (examVm.answers) {
          examVm.postExamAnswerQuestion();
        }
        window.onbeforeunload = null;
        navigate(`/exercises/confirmation/${guid}`);
      }
    }, 1000);
  };

  useEffect(() => {
    const storedDuration = parseInt(localStorage.getItem('countdownDuration'));
    if (storedDuration && !isNaN(storedDuration)) {
      startCountdown(storedDuration);
    } else {
      localStorage.setItem('countdownDuration', vm.intervalSeconds.toString());
      startCountdown(vm.intervalSeconds);
    }
  }, []);

  return (
    <TimerContainer>
      <TimerContent>
        <TimerTitle>
          <span>Cronômetro</span>
          <IconComponent name="view" onClick={() => vm.toggleViewTimer()} />
        </TimerTitle>
        <TimerInfo>
          {vm.viewTimer ? (
            <>
              <RemainingTime>{vm.formatSecondsToTime(vm.count)}</RemainingTime>
              <TotalTime>{`Tempo total: ${minutes} min`}</TotalTime>
            </>
          ) : (
            <TimerSkeletonContainer>
              <RemainingTimeSkeleton />
              <TotalTimeSkeleton />
            </TimerSkeletonContainer>
          )}
        </TimerInfo>
      </TimerContent>
    </TimerContainer>
  );
};

export default observer(ExamTimer);
